<template>
  <v-app>
    <v-main>
      <!--Laptop Menu-->
      <v-sheet style="z-index:1;position:fixed;left:0;right:0">
      <v-container  class="text-center hidden-md-and-down">
      <v-sheet style="margin:9px 3px 10px 0px;z-index:21">
        <v-row style="z-index:21">
          <v-col>
            <div>
            <v-img
              width="50px"
              height="50px"
              src="../../assets/Tippings.png"
            />
               </div>
               <div style='margin-left:20px;margin-top:-40px'>
              <router-link
                to="/"
                color="black"
                class="menuLink"
                active-class="active"
                >Home</router-link
              >
              <router-link to="/#about" class="menuLink">About</router-link>
              <router-link to="#features" class="menuLink">Features</router-link>
             </div>
          </v-col>

          <v-col style="float:right">
              <v-btn
                width="128px"
                height="40px"
                outlined
                class="pa-6 button"
                x-large
                color="red"
                style="margin-left:59px;border-radius:10px;
    color:white"
                to="/login"
                >Sign in</v-btn
              >
              <v-btn
               color="#E10712"
                height="40px"
                x-large
                style="margin-left:59px;border-radius:10px;
               color:white"
                to="/signup"
                class="pa-6"
                >Create free account</v-btn
              >
            
          </v-col>
        </v-row>
      </v-sheet>
    </v-container>
      </v-sheet>

      <v-container class="hidden-md-and-down">
        <v-row>
          <v-col sm="7" lg="7" md="7" style="margin-top:130px">
            <h1 style="font-size:50px;width:80%" class="font-weight-black">
              Creativity has a new ¢urre₦¢¥.
            </h1>
            <p style="width:60%;font-size:18px">
              Tippings helps African creatives build relationships and gain
              support from their fans
            </p>
            <v-btn
              color="#e10712"
              class="pa-5 button mt-2 font-weight-bold white--text"
              style="border-radius:15px"
              x-large
              to="/signup"
            >
              Create free account
            </v-btn>
          </v-col>
          <v-col sm="5" lg="5" md="5">
            <v-img
              style="margin-top:100px"
              class="animate__animated animate__fadeInUp"
              width="350px"
              src="../../assets/iPhone 12 Pro Mockup.png"
            />
          </v-col>
        </v-row>
      </v-container>





      <!--Mobile Menu -->
      <v-card  width="100%" flat height="80px" style="position:fixed;z-index:2"  color="white">
       <v-container color="white" class="pa-6 hidden-lg-and-up">
      <v-img
              width="50px"
              height="50px"
              src="../../assets/Tippings.png"
            />
            <v-btn
              class="hidden-lg-and-up"
              style="float:right;margin-top:-50px"
              color="black"
              icon
              large
              @click="drawer =! drawer"
              ><v-icon large>mdi-menu</v-icon></v-btn
            >
      </v-container>
      </v-card>

      <v-container class="text-center pa-3 hidden-lg-and-up">
        <h1
          style="margin-top:150px;text-align:center;font-size:39px"
          class="mx-5 mb-3 font-weight-black"
        >
          Creativity has a new ¢urre₦¢¥.
        </h1>
        <p style="margin:0px 10px 20px 10px;text-align:center">
          Tippings helps African creatives build relationships and gain support
          from their fans
        </p>
        <v-btn
              color="#e10712"
              class="pa-5 button mt-2 font-weight-bold white--text"
              style="border-radius:15px"
              x-large
              to="/signup"
              height="63px"
            >
              Create free account
            </v-btn>
            <div class="text-center pl-13">
            <v-img style="margin:30px auto auto auto" width="500px" src="../../assets/iPhone 12 Pro Mockup.png" />
            </div>
      </v-container>
    </v-main>
    <v-dialog v-model="drawer" fullscreen>
      <v-card>
       <v-container class="pa-7 hidden-lg-and-up">
      <v-img
              width="50px"
              height="50px"
              src="../../assets/Tippings.png"
            />
            <v-btn
              class="hidden-lg-and-up"
              style="float:right;margin-top:-50px"
              color="black"
              icon
              large
              @click="drawer =!drawer"
              ><v-icon large>mdi-close</v-icon></v-btn
            >
      </v-container>
      <div class="text-center">
      <div>
        <v-btn class="animate__animated animate__fadeInDown animate__faster" text>Home</v-btn>
        </div>
        <div>
        <v-btn class="animate__animated animate__fadeInDown animate__faster" text>About</v-btn>
        </div>
        <div>
        <v-btn class="animate__animated animate__fadeInDown animate__fast" text>Features</v-btn>
        </div>
        <div>
        <v-btn
               width="220px"
                height="40px"
                outlined
                class="mb-3 pa-6 button animate__animated animate__fadeInDown animate__slow"
                x-large
                color="black"
                style="border-radius:10px;
    color:white"
                to="/login"
                
                >Sign in</v-btn
              >
              </div>
              <div>
              <v-btn
               color="#E10712"
                height="40px"
                x-large
                style="border-radius:10px;
               color:white"
                to="/signup"
                class="pa-6 animate__animated animate__fadeInDown animate__slow"
                >Create free account</v-btn
              >
              </div>
        </div>
      </v-card>
      </v-dialog>
  </v-app>
</template>

<script>
export default {
  name: "Home",
  components: {
    
  },
  data(){
    return{
      drawer:false
    }
  }
}
  </script>

<style scoped>
.button:hover {
  color: white;
  background: black !important;
}

.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}
</style>
